import { ProductCategory } from "@store/product/product.store"

export const getCategoryFromChild = (
  category: ProductCategory
): ProductCategory => {
  return category?.child ? getCategoryFromChild(category.child) : category
}

export default getCategoryFromChild
